module.exports = __webpack_public_path__ + "img/logo_orange.ef49a461.svg";